/* ============================================================
   CARRITO — reserva + progreso + precio anterior por linea + fila del TOTAL
   + boton + precios de los recomendados.
   Copiado de icon-amsterdam.com (20 ago 2026)
   Los estilos van en `pn-carrito-total.css` y `pn-carrito-lineas.css`.

   SEIS COSAS:
     1. Barra verde "TU PEDIDO ESTA RESERVADO DURANTE mm:ss"
     2. Barra de progreso hacia el siguiente descuento (justo debajo)
     3. El precio ANTERIOR tachado en CADA LINEA, delante del actual
     4. Fila "TOTAL:  <tachado> <actual> <-Xeuros>" encima del boton
     5. El boton: candado + "FINALIZAR COMPRA"
     6. El precio anterior tachado en las tarjetas de recomendados

   ⚠⚠ CON LA CESTA VACIA NO SE PINTA NI LA BARRA VERDE NI LA DE PROGRESO.
   (20 ago 2026, a peticion suya.) Anunciar "tu pedido esta reservado" sin
   pedido no tenia ningun sentido. Por eso `ponerBarra()` NO se llama en
   `pintar()` a secas: se llama dentro del `.then` de `estado()`, que es
   quien sabe si hay articulos, y si no los hay se BORRAN las dos barras.

   ⚠⚠ LAS DOS BARRAS VAN SIEMPRE JUNTAS mientras haya algo en la cesta.
   Una version anterior escondia la verde al llegar a 00:00 y parecia que
   se habia borrado. Ahora, al llegar a cero, ARRANCA OTRA VEZ en 15:00.

   ============================================================
   🚩 EL CANDADO DEL BOTON (1 sep 2026, pedido suyo)
   ============================================================
   Copiado de gudslip.com: SVG de 16x16 a 8 px del texto.

   ⚠️ `ponerBoton()` YA NO PUEDE USAR `textContent`. Antes escribia el texto
   asi, y eso BORRARIA el candado en el siguiente repintado. Ahora escribe
   `innerHTML` y solo cuando falta algo — si ya estan el candado y el texto
   correcto, no toca nada. Sin esa comprobacion se reescribiria el boton en
   cada pasada y se volveria a los repintados en cadena.

   ============================================================
   🚩🚩 1 sep 2026 — EL RELOJ SE MORDIA LA COLA (ARREGLADO)
   ============================================================
   SINTOMA que lo destapo: el contador de prendas de la cabecera se veia
   PARPADEAR en vez de fijo.

   MEDIDO antes del arreglo, con una prenda en la cesta y el cajon abierto:
       10 peticiones a /cart.js en 5 segundos  (2 por segundo)
       el contador de la cabecera, ausente en 2 de cada 5 muestras

   CAUSA: `pintarReloj()` reescribe el `textContent` de `.pnr-reserva` cada
   segundo, y esa barra vive DENTRO de `#cart-drawer`, que es justo el nodo
   vigilado. El observador no estaba amortiguado y llamaba a `pintar()` en
   cada mutacion; `pintar()` pide `/cart.js` y vuelve a escribir en el cajon,
   lo que genera mas mutaciones. Bucle.

   ARREGLO, dos frenos en `vigilar()`:
     1. SE IGNORAN las mutaciones que salen de `.pnr-reserva`. El tic del
        reloj no es un cambio del carrito: no tiene por que repintar nada.
     2. El resto se AMORTIGUA 150 ms, para que un repintado del cajon (que
        genera decenas de mutaciones) provoque UNA pasada, no decenas.

   ⚠️ Si algun dia se anade otra cosa que se reescriba sola dentro del cajon
   (otro reloj, un carrusel automatico), hay que meterla en `IGNORAR`.
   ============================================================
   ⚠⚠ 22 ago 2026: EL ENVIO ES GRATIS SIEMPRE, SIN MINIMO
   ============================================================
   Se borro el metodo "Envio estandar 1,99" y se quito la condicion de
   >= 50 EUR del metodo "Envio gratis" en el perfil de envio. Verificado por
   API: el metodo queda a 0,00 EUR con `methodConditions: []`.

   Por eso AQUI YA NO HAY HITO DE ENVIO GRATIS. Antes la barra decia
   "Gasta X mas y consigue el envio gratis" con ENVIO_GRATIS = 5000
   centimos. Si alguien vuelve a poner un minimo de envio en Shopify,
   hay que volver a meter ese hito aqui.

   ⚠ LOS DOS HITOS QUE QUEDAN SON REALES, verificados por API:
        -15 % >= 2 prendas · -20 % >= 3 prendas
   Si alguno se desactiva en Shopify, HAY QUE TOCAR ESTO TAMBIEN.

   ============================================================
   ⚠⚠ DE DONDE SALEN LOS PRECIOS ANTERIORES — Y DE DONDE NO
   ============================================================
   NUNCA de `compare_at_price`. NO FUNCIONA EN ESTA TIENDA: el contextual
   pricing de Shopify para el mercado ES lo devuelve NULO en la tienda de
   cara al publico, aunque el Admin diga 129,90. Comprobado el 20 ago 2026
   por tres vias (products.js, products.json y Liquid en el carrito), las
   tres nulas, y reescribirlo por API tampoco lo arregla.

   El precio anterior real vive en el metacampo `custom.precio_antes`:
     · Linea y fila del TOTAL → JSON `#pn-compare-at` (variante → CENTIMOS),
                                que emite `snippets/carrito-pago-nazalea.liquid`
     · Recomendados           → `window.__PN_ANTES[handle]` (TEXTO ya
                                formateado), de `snippets/pn-rebaja-cards.liquid`
   ⚠ `window.__PN_ANTES` solo cubre vestidos, conjuntos y tops.

   🚩 EL TACHADO DE CADA LINEA (1 sep 2026, pedido suyo).
   La linea se empareja con su articulo POR ORDEN: la fila n del cuerpo de la
   tabla es `cart.items[n]`. No hay otra via limpia — el marcado de la fila no
   lleva el id de variante por ningun sitio (comprobado: ni en la fila, ni en
   el input de cantidad, que solo tiene `name="updates[]"`).

   🚩🚩 CUIDADO: `.cart-items__table-row` DEVUELVE UNA FILA DE MAS.
   La primera esta en el <thead> y es la cabecera invisible de la tabla
   ("Imagen del producto / Informacion del producto / Cantidad / Total"),
   que existe para los lectores de pantalla. Medido con UN articulo en la
   cesta: 2 filas para 1 articulo. Emparejar por posicion sin filtrarla
   desplaza TODO y no se pinta nada — me paso al primer intento.
   Por eso se filtran las filas que tienen `.cart-items__price`.

   ⚠️ Se compara y se pinta con TOTALES DE LINEA (precio x cantidad), que es
   lo que ensena el tema. Con cantidad 2 el tachado tambien se duplica.

   ⚠ EL CAJON SE REPINTA ENTERO cada vez que cambia el carrito: de ahi el
   MutationObserver y los `data-sig` (sin firma, bucle infinito).
   ============================================================ */
(function () {
  'use strict';

  var MINUTOS = 15;
  var CLAVE = 'pnrReservaInicio';
  var TEXTO = 'TU PEDIDO ESTÁ RESERVADO DURANTE';
  var TEXTO_BOTON = 'FINALIZAR COMPRA';

  /* 16x16, trazo del color del texto del boton. Ver el aviso del candado. */
  var CANDADO =
    '<svg class="pnr-candado" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
    'aria-hidden="true" focusable="false">' +
    '<rect x="4" y="10.5" width="16" height="10.5" rx="2"></rect>' +
    '<path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"></path>' +
    '</svg>';

  var PRENDAS_15 = 2;
  var PRENDAS_20 = 3;
  var NO_ES_PRENDA = 'proteccion-de-envio';

  /* Lo que se reescribe SOLO dentro del cajon y no debe repintar nada.
     Ver el aviso "EL RELOJ SE MORDIA LA COLA" de la cabecera. */
  var IGNORAR = '.pnr-reserva';

  /* ---------- utilidades ---------- */

  function dinero(centimos) {
    var s = (centimos / 100).toFixed(2).replace('.', ',');
    var partes = s.split(',');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + partes.join(',');
  }

  function comparativas() {
    var el = document.getElementById('pn-compare-at');
    if (!el) { return {}; }
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  }

  function handleDe(el) {
    var a = el.querySelector('a[href*="/products/"]');
    if (!a) { return null; }
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  /* ---------- 1. La cuenta atras ---------- */

  function guardarInicio(ms) {
    try { sessionStorage.setItem(CLAVE, String(ms)); } catch (e) { /* modo privado */ }
  }

  function inicio() {
    var v = null;
    try { v = sessionStorage.getItem(CLAVE); } catch (e) { v = null; }
    if (!v) { v = String(Date.now()); guardarInicio(v); }
    return parseInt(v, 10);
  }

  function quedan() {
    var fin = inicio() + MINUTOS * 60 * 1000;
    var seg = Math.floor((fin - Date.now()) / 1000);
    if (seg <= 0) { guardarInicio(Date.now()); return MINUTOS * 60; }
    return seg;
  }

  function reloj(seg) {
    var m = Math.floor(seg / 60);
    var s = seg % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  var tic = null;
  function arrancarReloj() {
    if (tic) { return; }
    tic = setInterval(pintarReloj, 1000);
    pintarReloj();
  }

  function pintarReloj() {
    var barras = document.querySelectorAll('.pnr-reserva');
    if (!barras.length) { return; }
    var t = TEXTO + ' ' + reloj(quedan());
    Array.prototype.forEach.call(barras, function (b) {
      b.hidden = false;
      if (b.textContent !== t) { b.textContent = t; }
    });
  }

  /* Solo se llama cuando SI hay articulos. Ver el aviso de la cabecera. */
  function ponerBarra() {
    var lista = document.querySelector('#cart-drawer .cart-drawer__items');
    if (!lista) { return; }
    if (lista.querySelector('.pnr-reserva')) { return; }
    var b = document.createElement('div');
    b.className = 'pnr-reserva';
    b.textContent = TEXTO + ' ' + reloj(quedan());
    lista.insertBefore(b, lista.firstChild);
  }

  /* Cesta vacia: fuera las dos barras. */
  function quitarBarras() {
    var n = document.querySelectorAll('#cart-drawer .pnr-reserva, #cart-drawer .pnr-progreso');
    Array.prototype.forEach.call(n, function (e) { e.remove(); });
  }

  /* ---------- 2. El estado del carrito ---------- */

  function estado() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c.items || !c.items.length) { return null; }
        var mapa = comparativas();
        var prendas = 0;
        var antes = 0;

        c.items.forEach(function (i) {
          if (i.handle !== NO_ES_PRENDA) { prendas += i.quantity; }
          var comp = mapa[i.variant_id];
          /* Sin precio anterior, el "antes" de esa linea es su propio
             precio: asi no se inventa un ahorro que no existe. */
          antes += (comp && comp > i.price ? comp : i.price) * i.quantity;
        });

        return {
          antes: antes,
          ahora: c.total_price,
          ahorro: antes - c.total_price,
          prendas: prendas,
          items: c.items,
          mapa: mapa
        };
      })
      .catch(function () { return null; });
  }

  /* ---------- 3. La barra de progreso ----------
     Sin hito de envio: el envio ya es gratis siempre. Ver la cabecera. */

  function meta(d) {
    if (d.prendas < PRENDAS_15) {
      return { texto: 'Añade <b>1 prenda</b> más y consigue un <b>15 %</b> de descuento', parte: d.prendas / PRENDAS_15 };
    }
    if (d.prendas < PRENDAS_20) {
      return { texto: 'Añade <b>1 prenda</b> más y consigue un <b>20 %</b> de descuento', parte: d.prendas / PRENDAS_20 };
    }
    return { texto: 'Ya tienes un <b>20 %</b> de descuento y el envío gratis', parte: 1 };
  }

  function ponerProgreso(d) {
    var lista = document.querySelector('#cart-drawer .cart-drawer__items');
    if (!lista || !d) { return; }

    var m = meta(d);
    var sig = m.texto + '|' + Math.round(m.parte * 100);
    var caja = lista.querySelector('.pnr-progreso');
    if (caja && caja.dataset.sig === sig) { return; }

    if (!caja) {
      caja = document.createElement('div');
      caja.className = 'pnr-progreso';
      caja.innerHTML = '<div class="pnr-progreso__txt"></div>'
                     + '<div class="pnr-progreso__pista"><div class="pnr-progreso__fill"></div></div>';
      var verde = lista.querySelector('.pnr-reserva');
      if (verde && verde.nextSibling) { lista.insertBefore(caja, verde.nextSibling); }
      else if (verde) { lista.appendChild(caja); }
      else { lista.insertBefore(caja, lista.firstChild); }
    }
    caja.dataset.sig = sig;
    caja.querySelector('.pnr-progreso__txt').innerHTML = m.texto;
    caja.querySelector('.pnr-progreso__fill').style.width = Math.min(100, Math.round(m.parte * 100)) + '%';
  }

  /* ---------- 4. El precio anterior de CADA LINEA ----------
     Ver los dos avisos de la cabecera: se empareja por orden, y HAY QUE
     FILTRAR la fila de cabecera del <thead>, que tambien lleva la clase
     `.cart-items__table-row` y no es ningun articulo. */

  function filasDePrenda() {
    var todas = document.querySelectorAll('#cart-drawer .cart-items__table-row');
    var out = [];
    Array.prototype.forEach.call(todas, function (f) {
      if (f.querySelector('.cart-items__price')) { out.push(f); }
    });
    return out;
  }

  function ponerLineas(d) {
    if (!d || !d.items) { return; }
    var filas = filasDePrenda();

    filas.forEach(function (fila, i) {
      var it = d.items[i];
      var caja = fila.querySelector('.cart-items__price');
      if (!it || !caja) { return; }

      var comp = d.mapa[it.variant_id];
      var puesto = caja.querySelector('.pnr-linea-antes');
      var ahora = it.final_line_price;
      var antes = comp ? comp * it.quantity : 0;

      /* Sin precio anterior real, o si no es mayor, NO se pinta nada: no se
         inventa un descuento que no existe. */
      if (!antes || antes <= ahora) {
        if (puesto) { puesto.remove(); }
        return;
      }

      var txt = dinero(antes);
      if (puesto) {
        if (puesto.textContent !== txt) { puesto.textContent = txt; }
        return;
      }
      var s = document.createElement('s');
      s.className = 'pnr-linea-antes';
      s.textContent = txt;
      caja.insertBefore(s, caja.firstChild);
    });
  }

  /* ---------- 5. La fila del TOTAL ---------- */

  function ponerTotal(d) {
    var caja = document.querySelector('#cart-drawer .cz-pago');
    if (!caja || !d) { return; }

    var sig = d.antes + '|' + d.ahora;
    var fila = caja.querySelector('.pnr-total');
    if (fila && fila.dataset.sig === sig) { return; }

    if (!fila) {
      fila = document.createElement('div');
      fila.className = 'pnr-total';
      caja.insertBefore(fila, caja.firstChild);
    }
    fila.dataset.sig = sig;

    var html = '<span class="pnr-total__lab">TOTAL:</span><span class="pnr-total__precios">';
    if (d.ahorro > 0) { html += '<span class="pnr-total__antes">' + dinero(d.antes) + '</span>'; }
    html += '<span class="pnr-total__ahora">' + dinero(d.ahora) + '</span>';
    if (d.ahorro > 0) { html += '<span class="pnr-total__ahorro">-' + dinero(d.ahorro) + '</span>'; }
    html += '</span>';
    fila.innerHTML = html;
  }

  /* ---------- 6. El precio anterior en los recomendados ---------- */

  function ponerPreciosReco() {
    var mapa = window.__PN_ANTES || {};
    var items = document.querySelectorAll('#cart-drawer .cz-rec__item');
    Array.prototype.forEach.call(items, function (item) {
      var caja = item.querySelector('.cz-rec__precios');
      if (!caja) { return; }
      var h = handleDe(item);
      if (!h) { return; }
      var antes = mapa[h];
      var puesto = caja.querySelector('.pnr-rec-antes');

      if (!antes) {
        if (puesto) { puesto.remove(); }
        return;
      }
      if (puesto) {
        if (puesto.textContent !== antes) { puesto.textContent = antes; }
        return;
      }
      var s = document.createElement('s');
      s.className = 'pnr-rec-antes';
      s.textContent = antes;
      caja.insertBefore(s, caja.firstChild);
    });
  }

  /* ---------- 7. El boton: candado + texto ----------
     Ver el aviso del candado: NO usar `textContent`, borraria el SVG. Y solo
     se reescribe si falta algo, para no repintar en cada pasada. */

  function ponerBoton() {
    var b = document.querySelector('#cart-drawer .cz-pago__boton');
    if (!b) { return; }
    var ok = b.querySelector('.pnr-candado') &&
             b.textContent.replace(/\s+/g, ' ').trim() === TEXTO_BOTON;
    if (ok) { return; }
    b.innerHTML = CANDADO + '<span>' + TEXTO_BOTON + '</span>';
  }

  /* ---------- montaje ---------- */

  function pintar() {
    ponerBoton();
    ponerPreciosReco();
    estado().then(function (d) {
      if (!d) {
        /* Cesta vacia: ni reloj ni barra de progreso. */
        quitarBarras();
        return;
      }
      ponerBarra();
      arrancarReloj();
      ponerProgreso(d);
      ponerLineas(d);
      ponerTotal(d);
    });
  }

  /* Ver el aviso "EL RELOJ SE MORDIA LA COLA" de la cabecera: sin estos dos
     frenos se pedia /cart.js dos veces por segundo. */
  function relevante(muts) {
    for (var i = 0; i < muts.length; i++) {
      var n = muts[i].target;
      var el = n.nodeType === 1 ? n : n.parentElement;
      if (el && el.closest && el.closest(IGNORAR)) { continue; }
      return true;
    }
    return false;
  }

  function vigilar() {
    var d = document.querySelector('#cart-drawer');
    if (!d || d.dataset.pnrVigilado === '1' || !window.MutationObserver) { return; }
    d.dataset.pnrVigilado = '1';
    var espera;
    new MutationObserver(function (muts) {
      if (!relevante(muts)) { return; }
      clearTimeout(espera);
      espera = setTimeout(pintar, 150);
    }).observe(d, { childList: true, subtree: true });
  }

  function iniciar() { pintar(); vigilar(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
  setTimeout(iniciar, 800);
  setTimeout(iniciar, 2000);
  /* Los recomendados los pinta `pn-carrito.js` con su propio ritmo. */
  setTimeout(ponerPreciosReco, 3000);
})();
